import React from "react";
import { useDispatchWrapper } from "./useDispatch";
import { showMessage } from "../redux/messages/messagesActions";
import { api } from "../api/api";
import { IUserProfile } from "../redux/UserProfileList/userProfile.types";

export const useToGetUser = () => {
  const [loading, setLoading] = React.useState(false);
  const [user, setUser] = React.useState<IUserProfile | null>(null); // Fixed type
  const dispatch = useDispatchWrapper();

  const fetchUsersByUserFactId = async (userFactId: number) => {
    try {
      setLoading(true);
      const res = await api.get(`/user/get-users?user_fact_id=${userFactId}`);
      const data: IUserProfile[] = res.data.data || [];
      
      if (data.length > 0) {
        setUser(data[0]); // Store the first user object
        return data[0];
      } else {
        setUser(null);
      }
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response?.data?.message || "An error occurred",
          displayAs: "snackbar",
        })
      );
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  return {
    user, // Access the stored user object
    fetchUsersByUserFactId,
    policiesLoading: loading,
  };
};
